/** 统一延期 API 响应校验（管理端） */
export const DEFER_DOMAIN_SERVICE = 'defer-domain-v1'

function normPeriod(p) {
  const s = String(p || '').trim().toLowerCase()
  if (s === 'dinner' || s === '晚餐') return 'dinner'
  if (s === 'lunch' || s === '午餐') return 'lunch'
  return s
}

/**
 * 校验延期成功响应（禁止仅用 HTTP 200 / code===200）
 * @param {object} resp axios 拦截器返回的 body
 * @param {{ requireService?: boolean }} opts
 */
export function validateDeferSuccessResponse(resp, opts = {}) {
  const requireService = opts.requireService !== false
  if (!resp || resp.success !== true) {
    return {
      ok: false,
      message: (resp && resp.message) || '延期失败'
    }
  }
  const data = resp.data
  if (!data || !data.mealId || !data.before || !data.after) {
    return {
      ok: false,
      message: '延期响应缺少 mealId / before / after 数据'
    }
  }
  const bDate = String(data.before.date || '').slice(0, 10)
  const aDate = String(data.after.date || '').slice(0, 10)
  const bPeriod = normPeriod(data.before.period)
  const aPeriod = normPeriod(data.after.period)
  if (bDate === aDate && bPeriod === aPeriod) {
    return {
      ok: false,
      message: '延期目标与当前计划相同，未发生实际变更'
    }
  }
  if (requireService && data.service && data.service !== DEFER_DOMAIN_SERVICE) {
    return {
      ok: false,
      message: `延期服务版本不匹配：${data.service}`
    }
  }
  return { ok: true, data }
}

/** 从 axios 错误或响应体提取服务端真实错误信息 */
export function extractDeferErrorMessage(e, resp, fallback = '延期失败') {
  if (resp && resp.success === false && resp.message) return String(resp.message)
  if (resp && resp.message && Number(resp.code) !== 200) return String(resp.message)
  if (e && e.apiBody) {
    const b = e.apiBody
    if (b.message) return String(b.message)
    if (b.error) return String(b.error)
  }
  if (e && e.response && e.response.data) {
    const d = e.response.data
    if (typeof d === 'string' && d.trim()) return d.trim()
    if (d && d.message) return String(d.message)
    if (d && d.error) return String(d.error)
  }
  if (e && e._networkHint) return e._networkHint
  if (e && e.message) return e.message
  return fallback
}

/** 批量延期响应校验 */
export function validateBatchDeferResponse(resp) {
  if (!resp) return { ok: false, message: '批量延期失败' }
  const data = resp.data || {}
  const failed = Number(data.failed) || 0
  const success = Number(data.success) || 0
  if (resp.success === false && failed === 0 && success === 0) {
    return { ok: false, message: resp.message || '批量延期失败', data }
  }
  return { ok: true, data, partial: failed > 0, message: resp.message || '' }
}
